import React from "react";
import _ from "lodash";
import Tooltip from "@leafygreen-ui/tooltip";
import IconButton from "@leafygreen-ui/icon-button";
import { FaEdit } from "react-icons/fa";
import { Table, TableHeader, Row, Cell } from "@leafygreen-ui/table";

export default function GraphicsList({
  graphics,
  setSelectedGraphic,
  showGraphicModal,
  initialGraphics,
  useARXfile,
  media,
  usePolarisRecipe,
  usePrintMode
}) {
  // console.log('* GraphicsList init')
  // console.log('- graphics: ', graphics)
  // console.log('- media: ', media)
  const columns = [
    <TableHeader label="SKU" sortBy={(datum) => datum.sku} />,
    <TableHeader label="Graphic File Name" />,
    <TableHeader
      label="ARX File Name"
      className={!useARXfile ? "hidden" : ""}
    />,
    <TableHeader label="Graphic Position" />,
    <TableHeader label="Rip Env" />,
    <TableHeader label="Platen" />,
    <TableHeader label="Size" />,
    <TableHeader label="Media(CADlink)" className={media && Boolean(media.length) ? "" : "hidden"} />,
    <TableHeader label="Print Mode(CADlink)" className={usePrintMode ? "" : "hidden"} />,
    <TableHeader label="Recipe(Polaris)" className={!usePolarisRecipe ? "hidden" : ""} />,
    <TableHeader label="Action" />,
  ];


  return (
    <>
      {Boolean(graphics.length) ? (
        <Table data={graphics} columns={columns}>
          {({ datum: graphic }) => (
            <Row key={graphic._id}>
              <Cell>{graphic.sku}</Cell>
              <Cell>
                {graphic?.graphicFileName ? graphic.graphicFileName : ""}
              </Cell>
              <Cell className={!useARXfile ? "hidden" : ""}>
                {graphic?.arxFileName ? graphic.arxFileName : ""}
              </Cell>
              <Cell>
                {graphic?.graphicPosition ? graphic.graphicPosition : ""}
              </Cell>
              <Cell>{graphic?.ripEnv ? graphic.ripEnv : ""}</Cell>
              <Cell>{graphic?.platen ? graphic.platen : ""}</Cell>
              <Cell>
                {!_.isNil(graphic?.size?.width)
                  ? `width: ${graphic?.size?.width}`
                  : !_.isNil(graphic?.size?.height)
                  ? `height: ${graphic?.size?.height}`
                  : ""}
              </Cell>
              {media && Boolean(media.length) && <Cell>{graphic?.media ? graphic.media : ""}</Cell>}
              <Cell className={!usePrintMode ? "hidden" : ""}>{graphic?.printMode ? graphic.printMode : ""}</Cell>
              <Cell className={!usePolarisRecipe ? "hidden" : ""}>{graphic?.polarisRecipe ? graphic.polarisRecipe : ""}</Cell>
              <Cell>
                <div className="action-btn-list">
                  <Tooltip
                    className="lg-tooltip-container"
                    darkMode={true}
                    align="left"
                    justify="start"
                    triggerEvent="hover"
                    aria-labelledby="Edit"
                    trigger={
                      <IconButton
                        className="swing-icon"
                        aria-labelledby="Edit"
                        onClick={() => {
                          // setSelectedGraphic({...initialGraphics, ...row.original})
                          showGraphicModal("update", {
                            ...initialGraphics,
                            ...graphic,
                          });
                        }}
                      >
                        <FaEdit />
                      </IconButton>
                    }
                  >
                    Edit
                  </Tooltip>
                </div>
              </Cell>
            </Row>
          )}
        </Table>
      ) : (
        <span>Graphics not found</span>
      )}
    </>
  );
}
